import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/cjs/Page/AnnotationLayer.css';
import 'react-pdf/dist/cjs/Page/TextLayer.css';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTenant } from '../contexts/TenantContext';
import useMenu from '../hooks/useMenu';
import { getBackendBaseOrigin } from '../utils/network';

// PDF.js worker - usa versione legacy compatibile
pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.legacy.js';

const Allergeni: React.FC = () => {
    const [numPages, setNumPages] = useState<number>(1);
    const [error, setError] = useState<string | null>(null);
    const navigate = useNavigate();
    const { tenantId } = useTenant();
    const { getDocumentUrl, loading } = useMenu();

    // Carica il documento allergeni dal backend
    const allergeniUrl = getDocumentUrl('ALLERGENI');
    const fullAllergenUrl = allergeniUrl?.startsWith('/') ? `${getBackendBaseOrigin()}${allergeniUrl}` : allergeniUrl;

    return (
        <div className="allergeni-page">
            <h2>Informazioni sugli allergeni</h2>
            {loading ? (
                <div style={{ textAlign: 'center', padding: '2rem' }}>Caricamento...</div>
            ) : error || !fullAllergenUrl ? (
                <div style={{ color: 'red', textAlign: 'center' }}>
                    Errore nel caricamento del PDF o documento non disponibile. <br />
                    {fullAllergenUrl && (
                        <a href={fullAllergenUrl} target="_blank" rel="noopener noreferrer">
                            Apri il PDF in una nuova scheda
                        </a>
                    )}
                </div>
            ) : (
                <Document
                    file={fullAllergenUrl}
                    onLoadSuccess={({ numPages }: { numPages: number }) => setNumPages(numPages)}
                    onLoadError={(err: Error) => setError(err.message)}
                >
                    {Array.from({ length: numPages }, (_, i) => (
                        <Page key={i + 1} pageNumber={i + 1} />
                    ))}
                </Document>
            )}
            <button
                className="modern-btn"
                onClick={() => navigate('/')}
                style={{
                    margin: '32px auto',
                    display: 'block',
                    padding: '12px 32px',
                    background: '#e91e63',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '8px',
                    fontWeight: 'bold',
                    fontSize: '1.1rem',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                    cursor: 'pointer',
                    transition: 'background 0.2s, color 0.2s'
                }}
                onMouseOver={e => (e.currentTarget.style.background = '#ad1457')}
                onMouseOut={e => (e.currentTarget.style.background = '#e91e63')}
            >
                Torna alla Home
            </button>
        </div>
    );
};

export default Allergeni;